// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","title":"Navbar_title__r0sUj"};